
export default {
  name: 'SpecialistSectionTitle',
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    tag: {
      type: String,
      default: 'h2'
    }
  }
}
